<div
  class="popup-notifications"
  appAddClassModifier
  bluClickOutside
  (clickedOutside)="closeNotifications()"
>
  <div class="popup-notifications__title">Notifications</div>
  @if (notifications.length > 0) {
    <div class="popup-notifications__notifications">
      @for (notification of notifications; track notification.id) {
        <div class="popup-notifications__notification">
          <app-popup-notification-item
            data-auto-id="closeNotificationsClick"
            (clicked)="closeNotifications(notification)"
            [notification]="notification"
          />
        </div>
      }
    </div>
  } @else {
    <div class="popup-notifications__message">
      No notifications at the moment
    </div>
  }
</div>
